import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import ProjectNav from "@/components/feature/ProjectNav";
import FrameOverlay from "@/components/base/FrameOverlay";
import FadeIn from "@/components/base/FadeIn";
import TiltCard from "@/components/base/TiltCard";
import { artistPortfolioImages } from "@/mocks/portfolio";
import { Link } from "react-router-dom";

export default function CassiusVelPage() {
  const works = artistPortfolioImages["cassius-vel"];

  return (
    <div className="min-h-screen bg-foreground-950 text-background-50">
      <Header />
      <main>
        <section className="bg-foreground-950 pt-32 md:pt-40 pb-24 md:pb-36">
          <div className="px-6 md:px-12">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
              <div>
                <p className="font-display text-xs uppercase tracking-[0.25em] text-background-50/50 mb-4 title-eyebrow">
                  ( Master Artist ) — Chiaroscuro
                </p>
                <h1 className="font-display font-black text-background-50 leading-[0.9] tracking-[-0.04em] text-[14vw] md:text-[10vw] lg:text-[9vw] whitespace-nowrap">
                  <span className="title-caps">Cassius</span>
                  <em className="font-serif italic font-light title-italic"> Vel</em>
                </h1>
              </div>
              <div className="max-w-md">
                <p className="text-base md:text-lg text-background-50/75 leading-relaxed font-serif">
                  A devotee of shadow — Cassius brings a sculptor&apos;s understanding of volume and a painter&apos;s command of gradient to every piece. His black and grey work achieves a depth usually reserved for marble sculpture.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3 mb-12" data-product-shop>
              {["Chiaroscuro", "Black & Grey", "Sculptural", "16 yrs"].map((tag, i) => (
                <span key={i} className="px-4 py-2 rounded-full border border-background-50/30 text-background-50 text-xs uppercase tracking-[0.18em] font-display">
                  {tag}
                </span>
              ))}
            </div>

            <div className="mb-16 md:mb-20 max-w-3xl">
              <p className="font-serif italic text-2xl md:text-3xl text-accent-500 leading-relaxed">
                &ldquo;Shadow is not the absence of light — it is its partner.&rdquo;
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-product-shop>
              {works.map((w, i) => (
                <FadeIn key={i} delay={i * 60} className="group cursor-pointer">
                  <TiltCard className="mb-3">
                    <div className={`img-hover ${w.aspect} bg-foreground-800 overflow-hidden relative`}>
                      <img src={w.image} alt={w.id} className="w-full h-full object-cover object-top" />
                      <FrameOverlay />
                    </div>
                  </TiltCard>
                  <div className="flex items-center justify-between">
                    <span className="font-display text-[11px] md:text-xs uppercase tracking-[0.2em] text-background-50">{w.id}</span>
                    <i className="ri-arrow-right-up-line text-background-50 text-base opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  </div>
                </FadeIn>
              ))}
            </div>

            <div className="mt-20 pt-12 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div>
                <p className="font-display text-sm uppercase tracking-[0.15em] text-background-50 mb-2">Begin Your Commission</p>
                <p className="text-background-50/70 font-serif text-sm">Consultations available Tuesday through Saturday.</p>
              </div>
              <Link
                to="/"
                state={{ faScrollTo: "booking" }}
                className="inline-flex items-center gap-3 px-8 py-4 bg-accent-500 text-foreground-950 font-display text-xs uppercase tracking-[0.2em] rounded-full hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Consultation
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <ProjectNav
          prev={{ label: "Isabella Rossi", to: "/artist/isabella-rossi" }}
          next={{ label: "Seraphina Dor", to: "/artist/seraphina-dor" }}
        />
      </main>
      <Footer />
    </div>
  );
}